import React, { useEffect, useState } from "react";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";
import { wire } from "react-hot-wire";

import CircularProgress from "@material-ui/core/CircularProgress";

import { PrizeService } from "services/prize/Prize.service";

import { Prize } from "models/prize/Prize";

import Drawer from "components/common/drawer/Drawer";

import EditPrize from "./Edit.template";

export type EditPrizeFormValues = {
  useCustom: boolean;
  name: string;
  customName: string;
  description: string;
  customDescription: string;
  supplierMargin: boolean;
  priceMargin: number;
  disabled: boolean;
};

const EditPrizeSchema = Yup.object().shape({
  useCustom: Yup.boolean(),
  name: Yup.string(),
  customName: Yup.string().when("$useCustom", {
    is: true,
    then: Yup.string().required()
  }),
  description: Yup.string(),
  customDescription: Yup.string().when("$useCustom", {
    is: true,
    then: Yup.string().required()
  }),
  supplierMargin: Yup.boolean(),
  priceMargin: Yup.number()
    .nullable()
    .min(0)
    .max(100),
  disabled: Yup.boolean()
});

function EditPrizeComponent({
  prizeService,
  drawerProps,
  action,
  ...props
}: {
  prize: Prize;
  prizeService: PrizeService;
  drawerProps?: any;
  action?: () => void;
}) {
  const [prize, setPrize] = useState<Prize | null>(null);

  useEffect(() => {
    (async () => {
      const prize = await prizeService.get(props.prize);

      setPrize(prize);
    })();
  }, [props.prize, prizeService]);

  return (
    <Drawer
      {...drawerProps}
      render={({ close }: { close: () => void }) =>
        prize ? (
          <Formik
            enableReinitialize
            isInitialValid
            initialValues={{
              useCustom: prize.useCustom,
              name: prize.name,
              customName: prize.useCustom ? prize.customName : prize.name,
              description: prize.description,
              customDescription: prize.customDescription
                ? prize.customDescription
                : prize.description,
              supplierMargin: !!!prize.priceMargin,
              priceMargin: prize.priceMargin,
              disabled: prize.disabled
            }}
            validationSchema={EditPrizeSchema}
            onSubmit={(values: EditPrizeFormValues) => {
              const data: any = {
                supplierMargin: values.supplierMargin,
                disabled: values.disabled
              };

              if (values.useCustom) {
                data.customName = { pl: values.customName };
                data.customDescription = { pl: values.customDescription };
              }

              if (values.priceMargin && !values.supplierMargin) {
                data.priceMargin = Number(values.priceMargin);
              }

              return prizeService
                .edit(prize, data)
                .then(close)
                .then(action);
            }}
            render={(props: FormikProps<EditPrizeFormValues>) => (
              <EditPrize
                formikProps={props}
                close={close}
                translationPath="prize.prize.edit"
              />
            )}
          />
        ) : (
          <div className="d-flex align-items-center justify-content-center h-100">
            <CircularProgress color="primary" />
          </div>
        )
      }
    />
  );
}

export default wire(["prizeService"], EditPrizeComponent);
